"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
//****Types****
__exportStar(require("./types/address"), exports);
__exportStar(require("./types/availability"), exports);
__exportStar(require("./types/base"), exports);
__exportStar(require("./types/biographical_information"), exports);
__exportStar(require("./types/category"), exports);
__exportStar(require("./types/collection_definition"), exports);
__exportStar(require("./types/collection_value_profile"), exports);
__exportStar(require("./types/competition"), exports);
__exportStar(require("./types/contact"), exports);
__exportStar(require("./types/court"), exports);
__exportStar(require("./types/court_position"), exports);
__exportStar(require("./types/draw_definition"), exports);
__exportStar(require("./types/draw_link"), exports);
__exportStar(require("./types/draw_link_source"), exports);
__exportStar(require("./types/draw_link_target"), exports);
__exportStar(require("./types/draw_structure"), exports);
__exportStar(require("./types/entry"), exports);
__exportStar(require("./types/event"), exports);
__exportStar(require("./types/extension"), exports);
__exportStar(require("./types/game"), exports);
__exportStar(require("./types/interleave"), exports);
__exportStar(require("./types/matchup"), exports);
__exportStar(require("./types/matchup_finishing_position_range"), exports);
__exportStar(require("./types/online_resource"), exports);
__exportStar(require("./types/organisation"), exports);
__exportStar(require("./types/participant"), exports);
__exportStar(require("./types/penalty"), exports);
__exportStar(require("./types/person"), exports);
__exportStar(require("./types/point"), exports);
__exportStar(require("./types/position_assignment"), exports);
__exportStar(require("./types/prize_money"), exports);
__exportStar(require("./types/registration_profile"), exports);
__exportStar(require("./types/score"), exports);
__exportStar(require("./types/seed_assignment"), exports);
__exportStar(require("./types/set"), exports);
__exportStar(require("./types/shot"), exports);
__exportStar(require("./types/side"), exports);
__exportStar(require("./types/statistic"), exports);
__exportStar(require("./types/team"), exports);
__exportStar(require("./types/team_competitor"), exports);
__exportStar(require("./types/tie_format"), exports);
__exportStar(require("./types/tie_win_criteria"), exports);
__exportStar(require("./types/time_item"), exports);
__exportStar(require("./types/tournament"), exports);
__exportStar(require("./types/unified_person_id"), exports);
__exportStar(require("./types/unified_team_id"), exports);
__exportStar(require("./types/unified_tournament_id"), exports);
__exportStar(require("./types/unified_venue_id"), exports);
__exportStar(require("./types/venue"), exports);
//****ENUMS****/
__exportStar(require("./types/enums/address_type"), exports);
__exportStar(require("./types/enums/ball_type"), exports);
__exportStar(require("./types/enums/category"), exports);
__exportStar(require("./types/enums/country_code"), exports);
__exportStar(require("./types/enums/court_position_names"), exports);
__exportStar(require("./types/enums/discipline"), exports);
__exportStar(require("./types/enums/draw_status"), exports);
__exportStar(require("./types/enums/draw_structure"), exports);
__exportStar(require("./types/enums/entry_status"), exports);
__exportStar(require("./types/enums/event_type"), exports);
__exportStar(require("./types/enums/finishing_position"), exports);
__exportStar(require("./types/enums/gender"), exports);
__exportStar(require("./types/enums/indoor_outdoor"), exports);
__exportStar(require("./types/enums/length_unit"), exports);
__exportStar(require("./types/enums/link_condition"), exports);
__exportStar(require("./types/enums/link_type"), exports);
__exportStar(require("./types/enums/matchup_status"), exports);
__exportStar(require("./types/enums/matchup_type"), exports);
__exportStar(require("./types/enums/online_resource_type"), exports);
__exportStar(require("./types/enums/organisation_type"), exports);
__exportStar(require("./types/enums/participant_role"), exports);
__exportStar(require("./types/enums/participant_status"), exports);
__exportStar(require("./types/enums/participant_type"), exports);
__exportStar(require("./types/enums/penalty_type"), exports);
__exportStar(require("./types/enums/playing_double_hand_code"), exports);
__exportStar(require("./types/enums/playing_hand_code"), exports);
__exportStar(require("./types/enums/positioning_profile"), exports);
__exportStar(require("./types/enums/sex"), exports);
__exportStar(require("./types/enums/shot_detail"), exports);
__exportStar(require("./types/enums/shot_outcome"), exports);
__exportStar(require("./types/enums/shot_type"), exports);
__exportStar(require("./types/enums/stage_type"), exports);
__exportStar(require("./types/enums/structure_type"), exports);
__exportStar(require("./types/enums/surface_category"), exports);
__exportStar(require("./types/enums/team_status"), exports);
__exportStar(require("./types/enums/tournament_level"), exports);
__exportStar(require("./types/enums/weekdays"), exports);
__exportStar(require("./types/enums/weight_unit"), exports);
__exportStar(require("./types/enums/wheelchair_class"), exports);
__exportStar(require("./types/enums/win_reason"), exports);
__exportStar(require("./types/enums/tournament_status"), exports);
__exportStar(require("./types/enums/national_associtation_sub_type"), exports);
//# sourceMappingURL=index.js.map